import StudentNote from './StudentNote';

export default StudentNote;
